var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaulticon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3319_12059)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 8,
    fill: "#D2D0D0"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3319_12059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 59H10C2.3 59 -4 52.7 -4 45L-2 10C-2 2.3 4.3 -4 12 -4H44C51.7 -4 58 2.3 58 10L59 45C59 52.7 52.7 59 45 59Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0974 41.7641L18.1974 32.6641L24.7307 39.1974L35.4641 28.4641L39.6641 32.6641V20.9974H27.9974L32.1974 25.1974L24.7307 32.6641L18.1974 26.1307L6.76406 37.5641C5.36406 34.5307 4.66406 31.2641 4.66406 27.9974C4.66406 15.1641 15.1641 4.66406 27.9974 4.66406C40.8307 4.66406 51.3307 15.1641 51.3307 27.9974C51.3307 40.8307 40.8307 51.3307 27.9974 51.3307C20.5307 51.3307 13.5307 47.8307 9.0974 41.7641Z",
    fill: "#D2D0D0"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 7.5,
    stroke: "#C0C3C9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3319_12059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3319_12059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaulticon);
export default __webpack_public_path__ + "static/media/Default icon.f51ea763287cc9b956bcf063959b4745.svg";
export { ForwardRef as ReactComponent };